const cumulativeCost = state => state.cumulativeCost
const currentTrends = state => state.currentTrends
const pastTrends = state => state.pastTrends
const finalEstimatedData = state => state.finalData.estimated || []
const finalPastData = state => state.finalData.past || []
const months = state => state.months
const regions = state => state.regions
const products = state => state.products
const status = state => state.status
const downloadLoading = state => state.downloadLoading
export default {
    cumulativeCost,
    currentTrends,
    pastTrends,
    finalEstimatedData,
    finalPastData,
    months,
    regions,
    products,
    status,
    downloadLoading
}
